import React, { memo } from 'react'
import Form, { FormConsumer } from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Input from '@active/react-ui/Input'
import Button from '@active/react-ui/Button'
import LinkButton from '@active/react-ui/LinkButton'
import Grid from '@active/react-ui/Grid'
import GridItem from '@active/react-ui/GridItem'
import { withI18n } from '@active/react-utils/i18n'
import Responsive from '@active/react-utils/components/Responsive'
import {
  func, string, number, oneOfType,
} from 'prop-types'
import I18nMessage from '../../../I18nMessage'
import './VerifyCodeOnly.scss'

function VerifyCodeOnly({
  countDownNumber,
  onSendCode,
  proxyForm,
  i18n,
},
) {
  const buttonText = 'passport.common.btn.send'
  return (
    <Form className="verify-code-only-form">
      <Grid fluid rowGap={0} colGap={0}>
        <GridItem span={12} spanSm={8}>
          <FormGroup name="code" className="relative" required withoutLayout>
            <FormLabel>
              <I18nMessage id="passport.verification.modal.input.placeholder" />
            </FormLabel>
            <FormField
              requiredError={i18n('passport.verification.modal.input.code.required.error')}
              placeholder={i18n('passport.verification.modal.input.code.placeholder')}
              as={Input}
              autoComplete="one-time-code"
            />
            <Responsive eqAbove="sm">
              <Button type="primary" className="sent-btn" onClick={onSendCode} disabled={!!countDownNumber}>{countDownNumber ? `${countDownNumber}s` : <I18nMessage id={buttonText} />}</Button>
            </Responsive>
          </FormGroup>
        </GridItem>
        <Responsive eqAbove="sm" not>
          <GridItem span={12} rowGap={0}>
            <LinkButton onClick={onSendCode} disabled={!!countDownNumber}>
              <I18nMessage id={buttonText} />
              {countDownNumber ? `(${countDownNumber}s)` : '' }
            </LinkButton>
          </GridItem>
        </Responsive>
      </Grid>
      <FormConsumer>
        {
                ({
                  form,
                }) => {
                  proxyForm(form)
                }
            }
      </FormConsumer>
    </Form>
  )
}

VerifyCodeOnly.propTypes = {
  countDownNumber: oneOfType([string, number]),
  proxyForm: func.isRequired,
  onSendCode: func.isRequired,
  i18n: func.isRequired,
}
VerifyCodeOnly.defaultProps = {
  countDownNumber: 0,
}
export default memo(withI18n(VerifyCodeOnly))
